import { PathSolver } from 'my-account-common'

class Config {
  constructor () {
    this.ptSessionsHistory = 'https://webservice' + PathSolver.getPathForEnvironment() + '.24hourfitness.com/api/rest/myaccount-member-current-agreements-process/getPTSessionHistory'
    this.clubVisitPDFDownload = 'https://webservice' + PathSolver.getPathForEnvironment() + '.24hourfitness.com/api/rest/myaccount-print-club-visits-process/PrintClubVisits'
    this.cvHistory = 'https://webservice' + PathSolver.getPathForEnvironment() + '.24hourfitness.com/api/rest/myaccount-get-club-visits-process/ClubVisits'
    this.agreements = 'https://webservice' + PathSolver.getPathForEnvironment() + '.24hourfitness.com/api/rest/myaccount-get-agreements-process/GetAgreements'
    this.personalTraining = 'https://webservice' + PathSolver.getPathForEnvironment() + '.24hourfitness.com/api/rest/myaccount-member-current-agreements-process/getPTSessionHistory'
    this.agreementsPDFDownload = 'https://webservice' + PathSolver.getPathForEnvironment() + '.24hourfitness.com/api/rest/myaccount-request-agreement-pdf-process/RequestAgreementPdf'
    this.sendLexmarkRequest = 'https://webservice' + PathSolver.getPathForEnvironment() + '.24hourfitness.com/api/rest/myaccount-request-agreement-copy-process/RequestAgreementCopy'
  }
}
let cfg = new Config()
export default cfg



// WEBPACK FOOTER //
// ./src/services/configuration/PropertiesConfiguration.js